import { DevicesService } from '../../services/devices/devices.service';
import { AppStoreService } from './app-store.service';
import * as SockJS from 'sockjs-client';
import { VehicleTrails } from '../../models/api/vehicle-trail.model';
import { UserService } from '../user.service';
import { AuthService } from '../auth.service';
import { Vehicle } from '../../models/api/vehicle.model';
import { PoiService } from '../poi.service';
import { SortData } from '../../models/sort.model';
import { FilterData } from '../../models/filter-input.model';
import { Position } from '../../models/api/vehicle-position.model';
import { AppState } from './app-state';
import { Injectable } from '@angular/core';
import { Store } from './store';
import { VehiclesService } from '../vehicles.service';
import { Observable, Subject, Subscription } from 'rxjs';
import {
  map,
  distinctUntilChanged,
  filter,
  bufferTime,
  take,
} from 'rxjs/operators';
import { Client, FrameImpl, IMessage, Versions } from '@stomp/stompjs';
import { environment } from '../../../environments/environment';
import { ColumnsService } from '../columns.service';
import { ColumnsData } from '../../models/api/column.model';
import { Pharmacy, PharmacyService } from '../pharmacy.service';
import _ from 'lodash';

@Injectable({
  providedIn: 'root',
})
export class AppStore extends Store<AppState> {
  updatePositions$: Observable<Position>;
  _updatePositions = new Subject<Position>();

  clientDSLocate: Client;
  positionBufferSub: Subscription;
  user = null;
  messages: Subject<any>;
  alreadyDownloadedTrails: string[] = [];

  constructor(
    private vehiclesService: VehiclesService,
    private devicesService: DevicesService,
    private poiService: PoiService,
    private columnService: ColumnsService,
    private authService: AuthService,
    private userService: UserService,
    private appStoreService: AppStoreService,
    private pharmacyService: PharmacyService
  ) {
    super(new AppState());
  }

  initApp() {
    this.updatePositions$ = this._updatePositions.asObservable();
    this.positionBufferSub = this.updatePositions$
      .pipe(bufferTime(5000))
      .subscribe((positions) => {
        this.updatePositionState(
          positions.sort((a, b) => (a.time > b.time ? 1 : -1))
        );
      });
    this.devicesService.devicesChanged.subscribe(() => {
      if (this.clientDSLocate.active) {
        this.clientDSLocate.forceDisconnect();
      }
    });
  }


  setFilterStateValue(value: FilterData): void {
    this.setState({
      ...this.state,
      filterVehicles: value,
    });
  }

  setSortStateValue(value: SortData): void {
    this.setState({
      ...this.state,
      sortData: value,
    });
  }

  setColumnStateValue(value: ColumnsData): void {
    this.setState({
      ...this.state,
      columns: value,
    });
  }

  pollForVehiclesWithPositions() {
    const user = this.authService.getUser();
    // if (!environment.production) {
    //   user = {
    //     login: 'login4251',
    //     password: '272c060199a8562a053073ff23ea4155',
    //   };
    // }
    const client = new Client({
      brokerURL: environment.websocketsUrl + 'fleetservice',
      connectHeaders: {
        login: user.login.replace(/\:/g, '\\c'),
        passcode: user.password,
      },
      debug: function () {},
      reconnectDelay: 5000,
      heartbeatIncoming: 30000,
      heartbeatOutgoing: 30000,
      stompVersions: new Versions(['1.1']),
    });
    client.onConnect = (frame: FrameImpl) => {
      if (frame.command === 'CONNECTED') {
        client.subscribe('/vehicles/positions', (res: IMessage) => {
          if (res.command === 'MESSAGE') {
            this.state$
              .pipe(
                filter(
                  (currentState) =>
                    !!currentState.columns.extColumns.length &&
                    !!currentState.vehicles &&
                    currentState.vehicles.length > 0
                ),
                map((currentState) => currentState.vehicles),
                distinctUntilChanged()
              )
              .subscribe((vehiclesDescriptions: Vehicle[]) => {
                switch (res.headers['message']) {
                  case 'vehicles positions': {
                    const vehicleTrails = JSON.parse(res.body);
                    const updatedTrails: VehicleTrails[] =
                      this.state.vehicleTrails;
                    const matchedTrail = updatedTrails.find(
                      (trail) =>
                        vehicleTrails.vehicle_id.toString() === trail.vehicleId
                    );
                    if (matchedTrail) {
                      matchedTrail.positions = [
                        ...vehicleTrails.vehicle_positions
                          .map((position) => {
                            return {
                              ...position,
                              time: position.timestamp.toString(),
                              vehicleId: vehicleTrails.vehicle_id,
                            };
                          })
                          .filter(
                            (position) =>
                              !matchedTrail.positions.find(
                                (currTrail) => currTrail.time === position.time
                              )
                          ),
                        ...matchedTrail.positions,
                      ];
                      matchedTrail.positions.sort((a, b) =>
                        a.time > b.time ? 1 : -1
                      );
                    } else {
                      updatedTrails.push({
                        vehicleId: vehicleTrails.vehicle_id.toString(),
                        positions: vehicleTrails.vehicle_positions.map(
                          (position) => {
                            return {
                              ...position,
                              timestamp: position.time.toString(),
                            };
                          }
                        ),
                      });
                    }
                    this.setState({
                      ...this.state,
                      vehicleTrails: updatedTrails,
                    });
                    break;
                  }
                  case 'current state':
                    let pharmacyListMap: any;

                    const positions: Position[] = JSON.parse(
                      res.body
                    ).vehicles.map((vehicle) => {
                      return this.appStoreService.mapFromDao(
                        vehicle,
                        vehiclesDescriptions,
                        this.state.columns.extColumns
                      );
                    });

                    this.state$
                      .pipe(
                        map((state) => state.pharmacyList),
                        filter((pharmacyList: Pharmacy[]) => {
                          return (
                            pharmacyList &&
                            Array.isArray(pharmacyList) &&
                            pharmacyList.length > 0
                          );
                        }),
                        take(1)
                      )
                      .subscribe((pharmacyList: Pharmacy[]) => {
                        if (
                          pharmacyList &&
                          Array.isArray(pharmacyList) &&
                          pharmacyList.length > 0
                        ) {
                          pharmacyListMap =
                            this.appStoreService.mapBaseStationsToVehicles(
                              this.state.pharmacyList,
                              positions
                            );

                          this.setState({
                            ...this.state,
                            pharmacyList: pharmacyListMap,
                          });
                        }
                      });

                    this.setState({
                      ...this.state,
                      positions,
                      vehicleTrails: positions.map((trail) => ({
                        vehicleId: trail.vehicle,
                        positions: [trail],
                      })),
                    });

                    break;
                  case 'vehicle update':
                    const position: Position = JSON.parse(res.body);

                    let positionMap = this.appStoreService.mapFromDao(
                      position,
                      vehiclesDescriptions,
                      this.state.columns.extColumns
                    );

                    // update pharmacy
                    let pharmacyListMapUpdate: any;

                    pharmacyListMapUpdate =
                      this.appStoreService.mapVehicleToPharmacy(
                        this.state.pharmacyList,
                        positionMap
                      );

                    this.setState({
                      ...this.state,
                      pharmacyList: pharmacyListMapUpdate,
                    });

                    // end update pharmacy

                    this._updatePositions.next(positionMap);
                    break;
                }
              });
          }
        });
        this.state$
          .pipe(
            map((currState: AppState) => currState.selectedVehicle),
            filter((selectedVehicle) => !!selectedVehicle),
            distinctUntilChanged()
          )
          .subscribe((selectedVehicle: Position) => {
            if (
              this.alreadyDownloadedTrails.indexOf(selectedVehicle.vehicle) ===
              -1
            ) {
              this.alreadyDownloadedTrails.push(selectedVehicle.vehicle);
              client.publish({
                destination: '/vehicles/positions',
                body: selectedVehicle.vehicle,
              });
            }
          });
      } else if (frame.headers['message'] === '\n') {
        client.publish({ destination: '', body: '\n' });
      }
    };
    client.onStompError = function (frame) {
      console.log('Broker reported error: ' + frame.headers['message']);
      console.log('Additional details: ' + frame.body);
    };
    client.activate();
  }

  subscribeToDSLocateDevices() {
    if (this.authService.isValidToken()) {
      this.clientDSLocate = new Client({
        webSocketFactory: () => {
          return new SockJS('https://dslocate.datasystem.pl/deviceservice/ws');
        },
        connectHeaders: { apiToken: this.authService.getToken() },
        debug: function () {},
        reconnectDelay: 5000,
        heartbeatIncoming: 30000,
        heartbeatOutgoing: 30000,
        stompVersions: new Versions(['1.1']),
      });
      let sessionId = '';
      this.clientDSLocate.onConnect = (frame: FrameImpl) => {
        if (frame.command === 'CONNECTED') {
          const url = (
            this.clientDSLocate.webSocket as any
          )._transport.url.replace('/websocket', '');
          sessionId = url.substring(url.lastIndexOf('/') + 1);
          this.clientDSLocate.subscribe(
            `/user/${sessionId}/positions`,
            (res: IMessage) => {
              if (res.command === 'MESSAGE') {
                this.state$
                  .pipe(
                    map((currentState) => currentState.devices),
                    take(1)
                  )
                  .subscribe((devicesInformation) => {
                    if (!JSON.parse(res.body).length) {
                      const position: Position = JSON.parse(res.body);
                      this._updatePositions.next(
                        this.appStoreService.dslocateMapFromDao(
                          position,
                          devicesInformation
                        )
                      );
                    } else {
                      const devicesList: number[] = JSON.parse(res.body);
                      const mappedDevices = devicesList.map((device) => {
                        return {
                          name: this.appStoreService.decimalToHexString(device),
                          vehicle: device.toString(),
                        };
                      });
                      const positions = this.state.positions;
                      mappedDevices.forEach((mappedDevice) => {
                        if (
                          !positions.find((position) => {
                            return position.vehicle === mappedDevice.vehicle;
                          })
                        ) {
                          positions.push(mappedDevice as unknown as Position);
                        }
                      });
                      this.setState({
                        ...this.state,
                        positions: positions,
                      });
                    }
                  });
              }
            }
          );
        } else if (frame.headers['message'] === 'h') {
          this.clientDSLocate.publish({ destination: '', body: 'h' });
        }
      };
      this.clientDSLocate.onWebSocketClose = (frame) => {
        if (!this.authService.isValidToken()) {
          this.clientDSLocate.deactivate();
        }
      };
      this.clientDSLocate.onStompError = function (frame) {
        console.log('Broker reported error: ' + frame.headers['message']);
        console.log('Additional details: ' + frame.body);
      };
      this.clientDSLocate.activate();
    } else {
      this.authService.logout();
    }
  }

  private updatePositionState(newPositions: Position[]): void {
    const oldState = this.state;
    const updatedPositions = Object.assign([], oldState.positions);
    const updatedTrails = oldState.vehicleTrails;

    newPositions.forEach((newPosition) => {
      const existingPosition = updatedPositions.findIndex((position) => {
        return position.vehicle === newPosition.vehicle;
      });
      if (existingPosition !== -1) {
        updatedPositions[existingPosition] = newPosition;
      } else {
        updatedPositions.push(newPosition);
      }

      const existingTrails = updatedTrails.find((position) => {
        return position.vehicleId === newPosition.vehicle;
      });
      if (existingTrails) {
        existingTrails.positions.push(newPosition);
        existingTrails.positions.sort((a, b) => (a.time > b.time ? 1 : -1));
      } else {
        updatedTrails.push({
          vehicleId: newPosition.vehicle,
          positions: [newPosition],
        });
      }
    });

    this.setState({
      ...this.state,
      ...{ positions: updatedPositions },
      ...{ vehicleTrails: updatedTrails },
    });
  }

  unselectVehicle(): void {
    this.setState({ ...this.state, selectedVehicle: undefined });
  }

  // selectPharmacy(pharmacy: Pharmacy): void {
  //   const selectedPharmacy = _.cloneDeep(pharmacy);
  //
  //   // Ustaw wybraną aptekę, resetuj pojazd
  //   this.setState(
  //     Object.assign({}, this.state, {
  //       selectedPharmacy: selectedPharmacy,
  //       selectedVehicle: null,
  //     })
  //   );
  //
  //   if (selectedPharmacy.position && selectedPharmacy.position.length > 0) {
  //     this.selectVehicleById(Number(selectedPharmacy.position[0].vehicle));
  //   }
  // }
  selectPharmacy(pharmacy: Pharmacy) {
    const selectedPharmacy: Pharmacy = _.cloneDeep(pharmacy);

    if (pharmacy.position && pharmacy.position[0]) {
      this.selectVehicle(selectedPharmacy.position[0], false); // 🔥 NIE RESETUJ APTEKI
    }

    this.setState({
      ...this.state,
      selectedPharmacy: selectedPharmacy,
    });
  }

  // selectVehicle(vehicle: Position): void {
  //   const selectedVehicle = Object.assign({}, vehicle);
  //
  //   // Ustaw wybrany pojazd, resetuj aptekę
  //   this.setState(
  //     Object.assign({}, this.state, {
  //       selectedVehicle: selectedVehicle,
  //       selectedPharmacy: null,
  //     })
  //   );
  // }

  selectVehicle(vehicle: Position, resetPharmacy = false): void {
    const selectedVehicle: Position = Object.assign({}, vehicle);
    this.setState({
      ...this.state,
      selectedVehicle: selectedVehicle,
      selectedPharmacy: resetPharmacy ? null : this.state.selectedPharmacy
    });
  }

  selectVehicleById(vehicleId: number): void {
    let foundVehicle = null;

    for (let i = 0; i < this.state.positions.length; i++) {
      if (this.state.positions[i].vehicle === vehicleId.toString()) {
        foundVehicle = this.state.positions[i];
        break;
      }
    }

    if (foundVehicle) {
      this.selectVehicle(foundVehicle);
    } else {
      console.warn('🔴 Nie znaleziono pojazdu o ID:', vehicleId);
    }
  }

  storePois(): Observable<void> {
    return this.poiService.getPois().pipe(
      map((pois) => {
        this.setState({
          ...this.state,
          pois,
        });
      })
    );
  }

  storePoisCategories(): Observable<void> {
    return this.poiService.getPoisCategories().pipe(
      map((poisCategories) => {
        this.setState({
          ...this.state,
          poisCategories,
        });
      })
    );
  }

  storeVehicles(): Observable<void> {
    return this.vehiclesService.getVehiclesList().pipe(
      map((vehicles) => {
        this.setState({
          ...this.state,
          vehicles,
        });
      })
    );
  }

  storeGetPharmacyList(): Observable<void> {
    return this.pharmacyService.getPharmacyList().pipe(
      map((pharmacyList: Pharmacy[]) => {
        this.setState({
          ...this.state,
          pharmacyList,
        });
      })
    );
  }

  refreshDevicesInformation(): Observable<void> {
    return this.devicesService.getDevices().pipe(
      map((devices) => {
        const positions = this.state.positions.map((position) => {
          const device = devices.find(
            (currDevice) => currDevice.id.toString() === position.vehicle
          );
          return {
            ...position,
            name: device
              ? device.description
                ? device.description
                : position.name
              : position.name,
          };
        });
        this.setState({
          ...this.state,
          positions,
          devices,
        });
      })
    );
  }

  storeColumns(): Observable<void> {
    return this.columnService.getColumns().pipe(
      map((columns) => {
        this.setState({
          ...this.state,
          columns,
        });
      })
    );
  }

  storeDisplaySettings(): Observable<void> {
    return this.userService.getDisplaySettings().pipe(
      map((displaySettings) => {
        this.setState({
          ...this.state,
          displaySettings: displaySettings,
        });
      })
    );
  }
}
